import React, { useEffect, useState } from "react";
// import PubSub from "pubsub-js";

const CountDown = ({ end, callback }) => {
  const [hms, setHms] = useState();

  const _calculateTimeLeft = () => {
    const endDate = new Date(end);
    const now = new Date();
    // const diffInSeconds = (endDate - now) / 1000;
    const diff = Math.abs(endDate.getTime() - now.getTime()); // in miliseconds
    const seconds = Math.floor(diff / 1000); // in second

    // console.log(diff, seconds);
    return seconds;
  };

  const [timeLeft, setTimeLeft] = useState(_calculateTimeLeft());

  const _secondsToHHMMSS = secs => {
    let hours = Math.floor(secs / 3600);
    let minutes = Math.floor((secs - hours * 3600) / 60);
    let seconds = secs - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    let obj = {
      h: hours,
      m: minutes,
      s: seconds
    };
    // // console.log(secs);
    // let hours = Math.floor(secs / 3600);
    // // let hours = Math.floor((secs / (1000 * 60 * 60)) % 24);
    // let minutes = Math.floor((secs / 1000 / 60) % 60);
    // let seconds = Math.floor((secs / 1000) % 60);

    // let obj = {
    //   h: addLeadingZeros(hours),
    //   m: addLeadingZeros(minutes),
    //   s: addLeadingZeros(seconds)
    // };
    return obj;
  };

  // const addLeadingZeros = value => {
  //   value = String(value);
  //   while (value.length < 2) {
  //     value = "0" + value;
  //   }
  //   return value;
  // };

  useEffect(() => {
    const timer = setTimeout(() => {
      const tl = _calculateTimeLeft();
      // console.log(tl);
      if (tl > 0) {
        setTimeLeft(tl);
      } else {
        clearTimeout(timer);
        _onEnd();
        // PubSub.publish("COUNDOWN_END");
      }
    }, 1000);

    return () => clearTimeout(timer);
  });

  useEffect(() => {
    // console.log(_secondsToHHMMSS(timeLeft));
    setHms(_secondsToHHMMSS(timeLeft));
  }, [timeLeft]);

  const _onEnd = () => {
    callback();
  };
  // console.log(hms.h);
  // const _hms = _secondsToHHMMSS(timeLeft);
  // console.log(_hms);
  return (
    <div className='countdown'>
      {/* {timeLeft} */}
      {hms && (
        <div className='timeleft tabular-nums'>
          {`${hms.h}:${hms.m}:${hms.s}`}
        </div>
      )}
    </div>
  );
};

export default CountDown;
